module.exports = __webpack_public_path__ + "img/Caught_underwater-Julien-Carrasco.fbf60966.jpg";